/**
 * Índice de masa corporal (Req. 16.3, 16.7; design.md, 8.5).
 *
 * IMC = peso (kg) / estatura (m)², con la tendencia de hoy y, sin tendencia,
 * con el último pesaje. Sin estatura no se calcula: se dice que falta (Req.
 * 16.7). Se muestra con un decimal (Req. 5.6) y sin categorías: la app no
 * califica el número.
 */

import { formatearNumero } from './numbers';
import type { PesajeBase, ResumenDePeso } from './tendencia';

export function calcularImc(pesoKg: number, estaturaCm: number): number {
  const metros = estaturaCm / 100;
  return pesoKg / (metros * metros);
}

export type ImcDeHoy =
  | { tipo: 'listo'; valor: number; base: 'tendencia' | 'ultimo'; pesoKg: number }
  | { tipo: 'falta_estatura' }
  | { tipo: 'falta_peso' };

export function imcDeHoy(resumen: Pick<ResumenDePeso<PesajeBase>, 'tendenciaKg' | 'ultimo'>, estaturaCm: number | null): ImcDeHoy {
  if (estaturaCm === null || !(estaturaCm > 0)) return { tipo: 'falta_estatura' };
  if (resumen.tendenciaKg !== null) {
    return { tipo: 'listo', valor: calcularImc(resumen.tendenciaKg, estaturaCm), base: 'tendencia', pesoKg: resumen.tendenciaKg };
  }
  if (resumen.ultimo !== null) {
    return { tipo: 'listo', valor: calcularImc(resumen.ultimo.pesoKg, estaturaCm), base: 'ultimo', pesoKg: resumen.ultimo.pesoKg };
  }
  return { tipo: 'falta_peso' };
}

/** "27.3" */
export function formatearImc(valor: number): string {
  return formatearNumero(valor, { decimales: 1 });
}
